import { IAPIContants } from 'src/constants/ApiConstants';
import { logger } from 'src/logger';
import { APIResponse, isHttpResponseJsonContent } from './ApiHelper';
import * as KatalMetrics from '@amzn/katal-metrics';
import { MetricsName, emitApiErrorMetrics } from 'src/metrics';

declare const AwsWafIntegration: any;

/**
 * This utility method is responsible to call fetch from WAF context.
 * It is responsible to handle metric emission.
 * @param api the API definition from IAPIContants
 * @param requestBody: request body.
 * @param onSuccessful: Function which is invoked on success of the function.
 * @param onFailure: Function which is invoked on failure of the function.
 */
export const callWafFetch = async (
  isAnonymousUser: boolean,
  api: IAPIContants,
  requestBody: any,
  onSuccessful: (data: APIResponse) => void,
  onFailure: (error: APIResponse) => void,
) => {
  const metric = new KatalMetrics.Metric.HttpRequest(
    MetricsName.BACKEND_REQUEST,
  ).withMonitor();

  const urlRoute = isAnonymousUser ? api.getPublicRoute() : api.getRoute();

  try {
    const response = await AwsWafIntegration.fetch(urlRoute, {
      method: api.method,
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    const responseBody = isHttpResponseJsonContent(response)
      ? response.json()
      : response.text();

    if (response.ok) {
      onSuccessful({ body: responseBody, status: response.status });
      logger.info(
        `Successfully recieved response from WAFFetch. Response received: `,
        response,
      );
      metric.setSuccess();
      api.metricsPublisher.publish(metric);
    } else {
      logger.error(
        'Not OK response code from WAFFetch. See error in context: ',
        { responseBody, response },
      );
      emitApiErrorMetrics(response, api.metricsPublisher);
      onFailure({ error: responseBody, status: response.status });
    }
  } catch (error: any) {
    logger.error('Failure from WAFFetch. See error in context: ', { error });
    emitApiErrorMetrics(error, api.metricsPublisher);
    onFailure({
      error,
      status: error.status || 'FETCH_ERROR',
    });
  }
};
